import React from "react";
import { useDispatch, useSelector } from "react-redux";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import { STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";
import { useState } from "react";
import { updateStudentPerformanceCommonResult } from "../../../redux/actions/studentPerformanceActions";

const StudentPerformanceCommonData = () => {
  const dispatch = useDispatch();
  const { commonResult: data, loading } = useSelector(
    (state) => state.studentPerformance,
  );
  // hansı sahə (portfolio / jury) edit modundadır
  const [editingField, setEditingField] = useState(null); // "portfolioResult" | "juryEvaluation" | null
  const [inputValue, setInputValue] = useState("");

  const updateItem = () => {
    dispatch({
      type: STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE.GET_STUDENT_PERFORMANCE_COMMON_MODAL,
      payload: {
        data: data,
        openModal: true,
      },
    });
  };

  // xanaya klik — edit modu aç
  const handleFieldClick = (field) => {
    setEditingField(field);
    const currentValue = data?.[field];
    setInputValue(
      currentValue === null || currentValue === undefined
        ? ""
        : String(currentValue),
    );
  };

  // input dəyişikliyi — 0-100 aralığı ilə məhdudlaşdır
  const handleInputChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setInputValue("");
      return;
    }

    const number = Number(value);

    if (!Number.isNaN(number) && number >= 0 && number <= 100) {
      setInputValue(value);
    }
  };

  // Enter və ya blur zamanı save et
  const handleSave = (field) => {
    const rawValue = inputValue;
    const newValue = rawValue === "" ? null : Number(rawValue);

    // dəyər dəyişməyibsə sorğu göndərmə
    if (newValue === (data?.[field] ?? null)) {
      setEditingField(null);
      return;
    }

    const payload = {
      portfolioResult: data?.portfolioResult ?? null,
      juryEvaluation: data?.juryEvaluation ?? null,
      [field]: newValue,
    };

    dispatch(updateStudentPerformanceCommonResult(data._id, payload));

    setEditingField(null);
  };

  const handleKeyDown = (e, field) => {
    if (e.key === "Enter") handleSave(field);
    if (e.key === "Escape") setEditingField(null);
  };

  const tHeadData = [
    {
      id: 1,
      name: "Cəm ortalaması",
    },
    {
      id: 2,
      name: "QB",
    },
    {
      id: 3,
      name: "Portfolio nəticəsi",
    },
    {
      id: 4,
      name: "Münsif dəyərləndirmə",
    },
    {
      id: 5,
      name: "Yekun ortalama balı",
    },
    {
      id: 6,
      name: "Sertifikat növü",
    },
    {
      id: 7,
      name: "",
    },
  ];

  return (
    <table className="details-table teacher-table student-performance-table ">
      <thead>
        <tr>
          {tHeadData.map((head) => (
            <th key={head.id}>{head.name}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={tHeadData.length}>
              <SmallLoading />
            </td>
          </tr>
        ) : (
          <tr>
            <td  >{data?.totalAverage ?? "-"}</td>
            <td>{data?.attendancePercentage ?? "-"}%</td>
            <td
              onClick={() => handleFieldClick("portfolioResult")}
              style={{ cursor: "pointer", minWidth: "60px" }}
            >
              {editingField === "portfolioResult" ? (
                <input
                  autoFocus
                  value={inputValue}
                  onChange={handleInputChange}
                  onBlur={() => handleSave("portfolioResult")}
                  onKeyDown={(e) => handleKeyDown(e, "portfolioResult")}
                  style={{
                    width: "50px",
                    fontSize: "12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "2px 4px",
                    outline: "none",
                  }}
                />
              ) : (
                <span>{data?.portfolioResult ?? "Yoxdur"}</span>
              )}
            </td>

            <td
              onClick={() => handleFieldClick("juryEvaluation")}
              style={{ cursor: "pointer", minWidth: "60px" }}
            >
              {editingField === "juryEvaluation" ? (
                <input
                  autoFocus
                  value={inputValue}
                  onChange={handleInputChange}
                  onBlur={() => handleSave("juryEvaluation")}
                  onKeyDown={(e) => handleKeyDown(e, "juryEvaluation")}
                  style={{
                    width: "50px",
                    fontSize: "12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "2px 4px",
                    outline: "none",
                  }}
                />
              ) : (
                <span>{data?.juryEvaluation ?? "Yoxdur"}</span>
              )}
            </td>
            <td  >{data?.commonAveragePoint ?? "-"}</td>
            <td>
              {data?.commonAveragePoint === 0 || data?.commonAveragePoint <= 60
                ? "Sertifikat"
                : data?.commonAveragePoint > 60 &&
                    data?.commonAveragePoint <= 90
                  ? "Diploma"
                  : data?.commonAveragePoint > 90 &&
                      data?.commonAveragePoint <= 100
                    ? "Honor Diploma"
                    : "-"}
            </td>
            <td>
              <UpdateDeleteModal
                updateItem={updateItem}
                data={data}
                profil="student-common-performance"
              />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default StudentPerformanceCommonData;
